import { inject } from 'vue'
import {
  portCallTypesKey,
  type PortCallTypesService
} from '@gat-ship/types/injection-keys'

/**
 * Inject the port-call-types service provided by a parent
 * `PortCallTypesProvider`.
 *
 * Throws when no provider is mounted — fail fast rather than papering over a
 * missing provider with an empty list. Consumers in other features can
 * equivalently call `inject(portCallTypesKey)` directly with the key from
 * `@gat-ship/types/injection-keys` and skip the dependency on this package.
 */
export function usePortCallTypes(): PortCallTypesService {
  const service = inject(portCallTypesKey)
  if (!service) {
    throw new Error(
      'usePortCallTypes() called without a <PortCallTypesProvider> ancestor.'
    )
  }
  return service
}

/**
 * Optional variant — returns `undefined` instead of throwing when no provider
 * is mounted. Useful for components that should degrade gracefully.
 */
export function usePortCallTypesOptional(): PortCallTypesService | undefined {
  return inject(portCallTypesKey, undefined)
}
